<template>
  <div class="save-recipe-button-wrapper">
    <ica-save-recipe-button
      v-model="isSavedComponent"
      :button-size="buttonSize"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { service } from '@/services/'
  import dataLayer from '@/analytics/dataLayer'
  import { IcaSaveRecipeButton } from '~/@ica/ica-molecules-vue/src/components'

  export default {
    name: "SaveRecipeButtonWrapper",
    components: {
      IcaSaveRecipeButton
    },
    props: {
      recipe: {
        type: Object,
        default: null
      },
      isSaved: {
        type: Boolean,
        default: false
      },
      buttonSize: {
        type: Number,
        default: 48
      },
      tracking: {
        type: Object,
        default: function () {
          return {}
        }
      },
    },
    data () {
      return {
        isSavedInner: this.isSaved, // On create isSaved gets its value from the prop (recipyBlock for example)
        saveRecipe: false
      }
    },
    computed: {
      isSavedComponent: {
        get () {
          // Sends the current value to the IcaSaveRecipeButton component.
          return this.isSavedInner
        },
        set (newValue) {
          // If the component sets a new value (i e when the user clicks the button) we do the api call.
          if (this.$root.isLoggedIn) {
            this.toggleSaveRecipe(newValue)
          } else {
            this.forceLogin()
          }
        }
      },
    },
    methods: {
      ...mapActions(['getPublicAccessToken']),
      forceLogin () {
        this.$ICALogin.forceUserLogin(this.$root.envConfig.loginEndpointUrl)
      },
      async toggleSaveRecipe (isSaved) {
        this.isSavedInner = !this.isSavedInner

        const serviceResponse = await service.toggleSaveRecipe({
          url: this.$root.envConfig.recipeExperienceApiBaseUrl,
          isSaved: isSaved,
          recipeId: this.recipe.id,
          publicAccessToken: await this.getPublicAccessToken()
        })

        dataLayer.add({
          event: isSaved ? 'recipeSave' : 'recipeUnsave',
          recipeId: String(this.recipe.id),
          recipeName: this.recipe.title,
          recipeUrl: this.recipe.url,
          succeeded: serviceResponse.success ? '1' : '0',
          ...this.tracking
        })

        // Revert change if unsuccesful
        if(!serviceResponse.success) {
          this.isSavedInner = !this.isSavedInner
        }
      }
    }
  }
</script>

<style lang="scss">
  .save-recipe-button-wrapper {
    position: absolute;
    top: 0;
    width: 100%;

    .save-recipe-button {
      position: absolute;
      right: 0.5rem;
      top: 0.5rem;
      z-index: 1;
    }
  }
</style>
